import { Grid } from '@mui/material'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import FormInput from 'components/FormInput'
import React, { useEffect, useState } from 'react'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from 'contexts/hearing-identification-block-fields.context'
import { GenderId } from 'utils/enums/gender.enum'
import FormInputNumber from 'components/FormInputNumber'
import { isFilled } from 'utils/validate.util'

type ChildrenGroupProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

const GENDERS_RESET_PREGNANT: string[] = [GenderId.NONE, GenderId.MASCULINO]

export const ChildrenGroup: React.FC<ChildrenGroupProps> = ({ control, watch, setValue }) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()

  const [genderBlock, setGenderBlock] = useState<boolean>(false)

  const genderIdValue = watch('idGenero')
  const estaGestanteValue = watch('identificacaoAdolescente.estaGestante')
  const hasChildren = watch('identificacaoAdolescente.possuiFilho')

  useEffect(() => {
    if (isFilled(genderIdValue) && GENDERS_RESET_PREGNANT.includes(String(genderIdValue))) {
      setValue('identificacaoAdolescente.estaGestante', 'N')
      setGenderBlock(true)
    } else {
      setGenderBlock(false)
    }
  }, [genderIdValue, estaGestanteValue, setValue])

  useEffect(() => {
    if (hasChildren === 'N') {
      setValue('identificacaoAdolescente.quantidadeFilho', null)
    }
  }, [hasChildren])

  return (
    <>
      <Grid item xs={3}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.estaGestante'
          label='Em gestação?'
          options={radioButtonChoiceOptions}
          disabled={isBlockedFields ? isBlockedFields : genderBlock}
        />
      </Grid>
      <Grid item lg={3} xs={12}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.possuiFilho'
          label='Tem filhos?'
          options={radioButtonChoiceOptions}
          disabled={isBlockedFields}
        />
      </Grid>
      {hasChildren === 'S' && (
        <>
          <Grid item lg={2} xs={12}>
            <FormInputNumber
              control={control}
              name='identificacaoAdolescente.quantidadeFilho'
              label='Quantidade?'
              placeholder='Informe a quantidade'
              maxLength={2}
            />
          </Grid>
          <Grid item lg={4} xs={12}>
            <FormInput
              control={control}
              name='identificacaoAdolescente.descricaoGuardaFilho'
              label='Quem ficará com a guarda? Algum possui deficiência? Artigo 185 Parágrafo 10 do CPP.'
              placeholder='Informe quem ficará com a guarda'
              maxLength={1400}
            />
          </Grid>
        </>
      )}
    </>
  )
}
